interface MyButtonProperties {
  label: string;
  buttonType:
    | 'submit'
    | 'back'
    | 'error'
    | 'outline'
    | 'active-outline'
    | 'active-outline-error'
    | 'warning'
    | 'primary-outline';
  disableHoverEffect?: boolean;
  svgIcon?: JSX.Element;
  onClickFunc?: () => void;
  valueRequired?: boolean;
  notifyCount?: number | null;
  loading?: boolean;
  disableButton?: boolean;
  svgBackIcon?: JSX.Element;
}

/**
 * Shared button component
 */
function MyButton({
  label,
  buttonType,
  svgIcon,
  disableHoverEffect,
  onClickFunc,
  valueRequired,
  notifyCount,
  loading,
  disableButton,
  svgBackIcon,
}: MyButtonProperties) {
  return (
    <div className="button-wrap">
      <button
        type="button"
        className={`${buttonType}-button ${disableHoverEffect ? '' : 'on-hover'} ${!loading && disableButton && 'disabled-color'}`}
        disabled={disableButton}
        onClick={onClickFunc}>
        {label && <span style={{ marginRight: '4px' }}>{label}</span>}
        {svgIcon && <span>{svgIcon}</span>}
        {svgBackIcon && <span className="icon">{svgBackIcon}</span>}
        {notifyCount && notifyCount > 0 ? (
          <span className="button-notifyCount">{notifyCount}</span>
        ) : (
          ''
        )}
        {valueRequired && <span className="value-required-indicator">*</span>}
      </button>
      {loading && (
        <div className="button-loader-wrap">
          <div className="button-loader-container">
            <div className="button-loader" />
          </div>
        </div>
      )}
    </div>
  );
}

MyButton.defaultProps = {
  onClickFunc: null,
  disableHoverEffect: false,
  valueRequired: false,
  svgIcon: null,
  notifyCount: null,
  loading: false,
  disableButton: false,
  svgBackIcon: null,
};

export default MyButton;
